import { render } from "./KapibaraReviews.vue?vue&type=template&id=253d1639"
import script from "./KapibaraReviews.vue?vue&type=script&lang=js"
export * from "./KapibaraReviews.vue?vue&type=script&lang=js"

import "./KapibaraReviews.vue?vue&type=style&index=0&id=253d1639&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__